module.exports = __webpack_public_path__ + "media/images/appTitle-db11f795549a4ecb83b27fb2f9cc8b7f.svg";